// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__i8CXP","sendOtp":"AuthorizeToLogin_sendOtp__2jfhn"};